export const daysToMilliseconds = (input: number) => (input * 24 * 3600 * 1000);

export function newDate(date: Date, daysToAdd?: number) {
  const newDate = new Date(date);
  if (daysToAdd > 0) {
    newDate.setDate(newDate.getDate() + daysToAdd);
  }
  return newDate;
}
